import {
  FormControl,
  InputLabel,
  Stack,
  TextField,
  Select,
  MenuItem,
} from "@mui/material";
import React, { useState, useContext, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { ParentScreenCtx } from "../../pages/workbench_build/WorkbenchBuild";
import { useSelector,useDispatch } from "react-redux";
import { eachDeep } from "deepdash-es/standalone";
import { cloneDeep,isArray,debounce } from 'lodash';
import { treeActions } from "../../redux/slices/treeSlice";

function OutboundActionProperties() {
  const { t } = useTranslation();
  const [actionName, setActionName] = useState("");
  const [action, setAction] = useState("");
  const [dbField, setDBField] = useState(t('SELECT'));
  const parentScreen = useContext(ParentScreenCtx);
  const { rightTree } = useSelector((state) => state.treeData[parentScreen]);
  const { translatedData, selectedNode } = rightTree.tree[rightTree.currentTab];
  const dispatch = useDispatch()
  const actionOptions = [
    { title: t("CLOSE_CUSTOMDB"), value: "CLOSE_CUSTOMDB" },
    { title: t("STOP_LOOPING"), value: "STOP_LOOPING" },
  ];
  const actionMenuOptions = actionOptions.map((obj, key) => (
    <MenuItem key={key} value={obj.value}>
      {t(obj.title)}
    </MenuItem>
  ));
  const extractDBFieldNames = (data, selectedNode) => {
    const names = [t('SELECT')];
    let stopSearch = false;

    const findCustomDbAboveSelectedNode = (node) => {
      if (stopSearch) {
        return;
      }

      if (node.key === selectedNode.key) {
        stopSearch = true;
        return;
      }

      if (node.TYPE === "QUERY" && node.NAME) {
        names.push(node.NAME);
      }

      if (node.children && node.children.length > 0) {
        node.children.forEach(findCustomDbAboveSelectedNode);
      }
    };

    data.forEach((node) => {
      findCustomDbAboveSelectedNode(node);
    });

    return names;
  };

  const dbFieldOptions = extractDBFieldNames(translatedData, selectedNode);
  const dbFieldMenuItems = dbFieldOptions.map((obj, key) => (
    <MenuItem key={key} value={obj}>
      {obj}
    </MenuItem>
  ));

  // Helper function to get localized action type display text
  const getActionTypeDisplayText = (actionValue) => {
    const actionOption = actionOptions.find(option => option.value === actionValue);
    return actionOption ? t(actionOption.title) : actionValue;
  };

  // Helper function to get raw action value from localized display text
  const getActionValueFromDisplayText = (displayText) => {
    const actionOption = actionOptions.find(option => t(option.title) === displayText);
    return actionOption ? actionOption.value : displayText;
  };

  const handleDBFieldChange = (key, value) => {
    const updatedData = eachDeep(cloneDeep(translatedData),obj =>{
      if (obj?.key !== selectedNode.key) {
        return;
      }
      if (key === "NAME") {
        obj.title = `${t("_ACTION_")} ${value}`;
      } else if (key === "OUTBOUND_ACTION_NAME") {
        obj.TYPE = getActionTypeDisplayText(action);
      } else if (key === "TYPE") {
        // When action type changes, update the TYPE to localized display text
        obj.TYPE = getActionTypeDisplayText(value);
      }
      obj[key] = value;

      if (isArray(obj?.children)) {
        return obj.children;
      }
      dispatch(
        treeActions.setRightTreeSelectedNode({
          screen: parentScreen,
          type: rightTree.currentTab,
          data: obj,
        })
      );
    });
    dispatch(
      treeActions.setNewRightTreeTranslatedData({
        screen: parentScreen,
        type: rightTree.currentTab,
        data: updatedData,
      })
    );
  };
  useEffect(() => {
    if(selectedNode){
      setActionName(selectedNode?.NAME || "")
      // Convert localized TYPE back to raw value for dropdown
      const rawActionValue = getActionValueFromDisplayText(selectedNode?.TYPE || "");
      setAction(rawActionValue)
      setDBField(selectedNode?.OUTBOUND_ACTION_NAME || t("SELECT"))
    }
  },[selectedNode])
  
  const debounceChangeHandler = debounce(handleDBFieldChange , 200)
  return (
    <Stack spacing={"15px"} className="tp-segment">
      <FormControl variant="outlined" className="width-100" size="small">
        <TextField
          size="small"
          label={t("LBL_NAME")}
          value={actionName}
          onChange={(e) => {
            setActionName(e.target.value);
            debounceChangeHandler("NAME", e.target.value)
          }}
        />
      </FormControl>
      <FormControl variant="outlined" className="width-100" size="small">
        <InputLabel id="actionDropdown">{t("_ACTION_")}</InputLabel>
        <Select
          className="width-100"
          MenuProps={{
            PaperProps: {
              sx: {
                maxHeight: 300,
              },
            },
          }}
          name="action"
          value={action}
          label={t("_ACTION_")}
          onChange={(e) => {
            setAction(e.target.value);
            debounceChangeHandler("TYPE", e.target.value)
          }}>
          {actionMenuOptions}
        </Select>
      </FormControl>

      {action !== "STOP_LOOPING" && (<FormControl variant="outlined" className="width-100" size="small">
        <InputLabel> {t("TIT_CUSTOM_DB_FIELD")} </InputLabel>
        <Select
          className="width-100"
          MenuProps={{
            PaperProps: {
              sx: {
                maxHeight: 300,
              },
            },
          }}
          name="customDBField"
          value={dbField}
          label={t("TIT_CUSTOM_DB_FIELD")}
          onChange={(e) => {
            setDBField(e.target.value);
            debounceChangeHandler("OUTBOUND_ACTION_NAME", e.target.value);
          }}>
          {dbFieldMenuItems}
        </Select>
      </FormControl>)
      }
    </Stack>
  );
}

export default OutboundActionProperties;
